import { useLocation } from 'react-router-dom';
import { PAGES } from '../common/enums';

const useCheckPage = () => {
  const location = useLocation();

  const isEmployeeConfigurationsPage = location.pathname.includes(PAGES.EMPLOYEE_CONFIGURATIONS);
  const isNewEmployeeConfigurationsPage = location.pathname.includes(PAGES.NEW_REFERENCE_CONFIGURATIONS);
  const isNewDriverConfigurationPage = location.pathname.includes(PAGES.NEW_CONFIGURATIONS);
  const isDriverConfigurationPage =
    location.pathname.includes(PAGES.CONFIGURATIONS) && !location.pathname.includes(PAGES.NEW_CONFIGURATIONS);
  const isContractsPage = location.pathname.includes(PAGES.CONTRACTS);

  return {
    isEmployeeConfigurationsPage,
    isNewDriverConfigurationPage,
    isNewEmployeeConfigurationsPage,
    isDriverConfigurationPage,
    isContractsPage
  };
};

export default useCheckPage;
